<template>
    <div class="videoUploadCon">
      <div class="add" @click="addVideo">
        <img src="../../img/plus.png" alt="" />
      </div>
      <div class="videoItem" v-for="item in myVideoList" :key="item.works_id">
        <div class="coverCon">
          <img :src="'https://collection2021-cos.chineseplus.net/'+item.video_cover" alt="" class="cover">
          <div class="fail" v-if="item.status == 2">
            <span>
              本作品参赛审核未通过，{{item.check_desc}}
            </span>
          </div>
          <div class="info">
            <img src="../../img/m/video_btn.png" alt="">
            <span>{{item.title}}</span>
          </div>
        </div>
        <div class="hoverInfo">
          <div class="info">
            <img src="../../img/m/video_btn.png" alt="">
            <span>{{item.title}}</span>
            <div class="des" v-if="item.status !== 2">
              {{item.desc}}
            </div>
            <div class="fail" v-if="item.status == 2">
                本作品参赛审核未通过，{{item.check_desc}}
            </div>
            <div class="operate">
              <div class="item" @click="getPlayAuth(item.video_url)">
                <img src="../../img/playicon.png" alt="">
                <div>
                  播放
                </div>
              </div>
              <div class="item" v-if="item.status == 0||item.status == 2" @click="editVideo(item.works_id)">
                <img src="../../img/editicon.png" alt="">
                <div>
                  编辑
                </div>
              </div>
              <div class="item" v-if="item.status == 0||item.status == 2" @click="deleteVideo(item.works_id)">
                <img src="../../img/deleteicon.png" alt="">
                <div>
                  删除
                </div>
              </div>
              <div class="item" v-if="item.status == 0||item.status == 2" @click="join(item.works_id)">
                <img src="../../img/m/flag_r1.png" alt="">
                <div>
                  参赛
                </div>
              </div>
              <div class="item isJoin" v-if="item.status == 3 || item.status == 1">
                <img src="../../img/join_black.png" alt=""  >
                <div v-if="item.status == 3">
                  审核中
                </div>
                <div v-if="item.status == 1">
                  已参赛
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="playContainer" v-if="currentVideo.isShow">
        <div class="closeVideo" @click="closePlayer">×</div>
        <div class="player">
          <vue-aliplayer-v2
          class="multiple-player"
          
          ref="VueAliplayerV2"
          v-if="options.vid"
          :options="options"
        />
        </div>
      </div>
      <el-dialog
      :visible.sync="dialogVisible"
      width="560px"
      height="635px"
      :close-on-click-modal="false"
      custom-class="uploadDialog"
      :before-close="closeUploadVideo"
    >
      <template slot="title">
        <div class="title">短视频上传</div>
      </template>
      <div class="stepInfo">
        <span :class="{ currentStep: videoUploadStep == 1 }"
          >上传短视频封面</span
        >
        <img src="../../img/new_arrow.png" alt="" /><span
          :class="{ currentStep: videoUploadStep == 2 }"
          >上传短视频文件</span
        >
        <img src="../../img/new_arrow.png" alt="" /><span
          :class="{ currentStep: videoUploadStep == 3 }"
          >上传短视频信息</span
        >
      </div>
      <div class="content">
        <div class="uploadVideoPic" v-show="videoUploadStep == 1">
          <label
            class="el-form-item__label"
            style="
              width: 100px;
              margin-top: -5px;
              margin-left: 10px;
              font-size: 18px;
            "
            >选择封面</label
          >
          <el-upload
            class="upload-demo"
            ref="upload"
            action="https://jsonplaceholder.typicode.com/posts/"
            :on-change="videoPicChange"
            :show-file-list="false"
            accept="image/*"
            :auto-upload="false"
          >
            <el-button
              slot="trigger"
              size="small"
              type="primary"
              class="chooseFile"
              ><img src="../../img/camera.png" alt="" /> 选择文件</el-button
            >
            <span v-if="videoFilePicList.length == 0&&!infoForm.video_cover" class="fileName"
              >未选择任何文件</span
            >
            <span v-if="videoFilePicList.length > 0" class="fileName" :title="videoFilePicList[0].name">{{
              videoFilePicList[0].name
            }}</span>
            <span class="coverImg">
              <img :src="'https://collection2021-cos.chineseplus.net/'+infoForm.video_cover" alt="" v-if="videoFilePicList.length == 0&&infoForm.video_cover">
            </span>
            <div class="imgTip">
              视频封面图片要求为JPG、gif、png格式，文件大小不大于10MB。
            </div>
          </el-upload>
          <div class="footer">
            <el-button
              type="primary"
              class="submitBtn"
              v-on:click="next"
              :disabled="isuploadPic"
              >下一步</el-button
            >
            <img
              src="../../img/loading.gif"
              alt=""
              class="loading"
              v-if="isuploadPic"
            />
          </div>
        </div>
        <div class="uploadVideoContent" v-show="videoUploadStep == 2">
          <div v-show="!uploadingVideo">
            <label
              class="el-form-item__label"
              style="
                width: 100px;
                margin-top: -5px;
                margin-left: 10px;
                font-size: 18px;
              "
              >选择视频</label
            >
            <el-upload
              class="upload-demo"
              ref="upload"
              action="https://jsonplaceholder.typicode.com/posts/"
              :on-change="videoChange"
              :show-file-list="false"
              accept="video/*"
              :auto-upload="false"
            >
              <el-button
                slot="trigger"
                size="small"
                type="primary"
                class="chooseFile"
                ><img src="../../img/videoicon.png" alt="" /> 选择文件</el-button
              >
              <span v-if="!file && !infoForm.video_url" class="fileName"
                >未选择任何文件</span
              >
              <span v-if="file" class="fileName" :title="file.name">{{
                file.name
              }}</span>
              <span v-if="!file && infoForm.video_url" class="fileName"
                >已选择文件</span
              >
              <div class="imgTip">支持mp4格式，文件最大为1G。</div>
            </el-upload>
            <div class="footer">
              <el-button
                type="primary"
                class="submitBtn"
                v-on:click="stsUpload"
                :disabled="uploadDisabled"
                >下一步</el-button>
            </div>
          </div>
          <div v-show="uploadingVideo" class="uploading">
            <img src="../../img/upload.gif" alt="" class="gif" v-show="!isEnd">
            <img src="../../img/upload_success.gif" alt="" v-show="isEnd">
            <div>
              {{statusText}}
            </div>
          </div>
        </div>
        <div class="uploadInfo" v-show="videoUploadStep == 3">
          <el-form :model="infoForm" ref="infoForm" :rules="formRules" label-width="90px" class="ruleForm">
                <el-form-item
                    size="small"
                    label="标题"
                    prop="title"
                    :rules="[
                    { required: true, message: '标题不能为空'},
                    { min: 1, max: 30, message: '字数在30个字以内', trigger: 'blur' }
                    ]"
                >
                  <el-input v-model="infoForm.title" placeholder="字数在30个字以内"></el-input>
                </el-form-item>
                <el-form-item
                        size="small"
                        label="描述"
                        prop="desc"
                        :rules="[
                        { min: 1, max: 150, message: '字数在150个字以内', trigger: 'blur' }
                        ]"
                >
                    <el-input  type="textarea" v-model="infoForm.desc" :rows="5"  autocomplete="off" placeholder="字数在150个字以内"></el-input>
                </el-form-item>
                <el-form-item 
                    size="small"
                    label="拍摄时间"
                    prop="time"
                    :rules="[
                    { required: true, message: '拍摄时间不能为空'},
                    ]"
                
                >
                    <el-col>
                    <el-date-picker type="month" :editable="false"  v-model="infoForm.time" 
                    format="yyyy 年 MM 月" :clearable='false'
                    style="width: 100%;" ></el-date-picker>
                    </el-col>
                </el-form-item>
                <el-form-item
                    class="placeWrapper"
                    size="small"
                    label="拍摄国家"
                    prop="sid"
                    :rules="[
                    { required: true, message: '拍摄国家不能为空'},
                    ]"
                >
                  <el-select v-model="infoForm.sid" class="continentSelect" no-data-text="请选择国家">
                    <el-option  v-for="country in countryList" v-bind:key="country.$index" :label="country.cn" :value="country.sid"></el-option>
                  </el-select>
                </el-form-item>
                <!-- <el-form-item
                    size="small"
                    label="拍摄地点"
                    prop="recording_place"
                    :rules="[
                    { required: true, message: '拍摄地点不能为空'},
                    { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' }
                    ]"
                >
                  <el-input v-model="infoForm.recording_place"  autocomplete="off"></el-input>
                </el-form-item> -->
                <el-form-item
                    size="small"
                    label="作品类型"
                    prop="category_id"
                    :rules="[
                    { required: true, message: '作品类型不能为空'},
                    ]"
                >
                    <el-select v-model="infoForm.category_id" @change="categoryChange" class="selectCon" >
                        <el-option
                          v-for="item in categoryList" 
                          v-bind:key="item.$index"
                          v-bind:label="item.category_name"
                          v-bind:value="item.category_id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    size="small"
                    label="作品话题"
                    prop="topic_id"
                    :rules="[
                    { required: true,message: '作品话题不能为空'},
                    ]"
                >
                    <el-select v-model="infoForm.topic_id" no-data-text="请先选择作品类型">
                    <el-option v-for="(value, key, index) in topicList"  v-bind:key="index"  :label="value.topic_name" :value="value.topic_id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div class="footer">
              <el-button
              type="primary"
              class="submitBtn"
              v-on:click="submitVideoInfo"
              >提交</el-button> 
              <span class="closeBtn" @click="closeUploadVideo">关闭</span>
            </div>
        </div>
      </div>
      </el-dialog>
    </div>
</template>

<script>
import VueAliplayerV2 from "vue-aliplayer-v2";
import {mapGetters} from 'vuex'
export default {
    name: 'videoUploadCon',
    components: {
      VueAliplayerV2
    },
    data: function () {
    return {
      isEdit: false,
      dialogVisible: false,
      videoUploadStep: 1, // 1:视频封面 2：视频文件 3：视频信息
      videoFilePicList: [], // 选择视频封面文件
      isuploadPic: false,
      timeout: "",
      partSize: "",
      parallel: "",
      retryCount: "",
      retryDuration: "",
      region: "cn-shanghai",
      userId: "111",
      file: null,
      stsProgress: 0,
      uploadDisabled: true,
      resumeDisabled: true,
      pauseDisabled: true,
      statusText: "",
      pauseDisabled: true,
      uploader: null,
      uploadFileName: "",
      isEnd: false,
      uploadInfo: {},
      uploadingVideo: false,
      countryList: [],
      topicList: [],
      categoryList: [],
      formRules: {},
      infoForm: {
        title: '',
        category_id: '',
        topic_id: '',
        desc: '',
        time: '',
        sid:'',
        video_cover: '',
        video_url: ''
      },
      myVideoList: [], // 我的短视频
      currentVideo: {
        isShow: false
      },
      options: {
        vid: "",
        playauth: "",
        height: '500px'
      }
    };
  },
  computed: {
    ...mapGetters(['getUserInfo']),
  },
  created() {
    this.getCountryList()
    this.getCategoryList()
    this.getMyVideoList()
    if (!window.AliyunUpload) {
      this.loadScript("lib/aliyun-upload-sdk/lib/es6-promise.min.js");
      this.loadScript("lib/aliyun-upload-sdk/lib/aliyun-oss-sdk-6.13.0.min.js");
      this.loadScript("lib/aliyun-upload-sdk/aliyun-upload-sdk-1.5.2.min.js");
    }
  },
  mounted() {
    if(this.getUserInfo.isLogin) {
      if(this.getUserInfo.volunteer_info == 0) {
        this.$router.push('/pcpage/userinfo')
      }
    }
  },
  methods: {
    // 参赛
    join(works_id) {
      this.$message({
        message: "作品征集已截止",
        type: "warning",
      });
      return
      this.$utils.postJson('/works/submitReview', {
        works_id
      }).then(res => {
        if(res.code == 1000) {
          this.$message.success(`作品已经提交审核，审核期间您的作品暂时不可以修改`);
          this.getMyVideoList()
        }
      })
    },
    // 获取作品详情
    editVideo(id) {
      this.$message({
        message: "作品征集已截止",
        type: "warning",
      });
      return
      this.$utils.get('/works/getInfo', {
        works_id: id
      }).then(res => {
        this.isEdit = true
        this.videoUploadStep = 1
        let data = res.data
        this.file = null
        var time = new Date(data.time*1000)
        this.infoForm.works_id = data.works_id
        this.infoForm.title = data.title
        this.infoForm.desc = data.desc
        this.infoForm.video_cover = data.video_cover
        this.infoForm.video_url = data.video_url
        this.infoForm.time = time
        this.infoForm.sid = data.sid
        this.infoForm.category_id = data.category_id
        this.infoForm.topic_id = data.topic_id
        this.dialogVisible = true
        this.uploadDisabled = false
        this.uploadingVideo = false
        this.getTopicList(this.infoForm.category_id)
      })
    },
    // 获取播放凭证
    getPlayAuth(vid) {
      this.$utils.get('/works/getPlayAuth', {
        video_id: vid
      }).then(res => {
        this.currentVideo.PlayAuth = res.data.PlayAuth
        this.currentVideo.vid = vid
        
        this.options.vid = vid
        this.options.playauth = res.data.PlayAuth
        this.currentVideo.isShow = true
      })
    },
    // 登录
    loginFun () {
      const currentUrl = window.location.href
      window.location.href = 'https://collection2021.chineseplus.net/user/login?callback=' + currentUrl
    },
    // 获取我的短视频
    getMyVideoList() {
      this.$utils.get('/works/myWorks', {
        type: 1
      }).then(res => {
        if(res.code == 1000) {
          this.myVideoList = [...res.data.video]
        }
        else if(res.code == 1002) {
          this.$confirm('当前未登录，前往登录？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.loginFun()
          })
        }
      })
    },
    addVideo() {
      this.$message({
        message: "作品征集已截止",
        type: "warning",
      });
      return
      if(this.getUserInfo.isLogin) {
        this.dialogVisible = true
        this.videoUploadStep = 1
        this.uploadingVideo = false
        this.isEdit = false
        this.file = null
        this.videoFilePicList = []
        this.infoForm =  {
          title: '',
          category_id: '',
          topic_id: '',
          desc: '',
          time: '',
          sid:'',
          video_cover: '',
          video_url: ''
        }
      } else {
        this.loginFun()
      }
      
    },
    deleteVideo(works_id) {
      this.$message({
        message: "作品征集已截止",
        type: "warning",
      });
      return
      this.$confirm('您确定要删除该作品吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$utils.postJson('/works/delWorks', {
          works_id
        }).then(res => {
          if(res.code == 1000) {
            this.$message({
              message: "删除成功！",
              type: "success",
            });
            this.getMyVideoList()
          }
        })
      })
    },
    submitVideoInfo() {
      this.$message({
        message: "作品征集已截止",
        type: "warning",
      });
      return
      let url = '/works/api/submitVideo'
      if(this.isEdit) {
        url = '/works/api/updateVideo'
      }
      this.$refs['infoForm'].validate((valid) => {
        if(valid) {
          this.$utils.postJson(url, this.infoForm).then(res => {
          this.dialogVisible = false
          this.videoUploadStep = 1
          this.getMyVideoList()
          this.infoForm =  {
            title: '',
            category_id: '',
            topic_id: '',
            desc: '',
            time: '',
            sid:'',
            video_cover: '',
            video_url: ''
          }
          this.refs.infoForm.resetFields()
          if(res.code == 1001) {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        })
        }
      })

      
    },
    // 动态加载oss库
    loadScript(url) {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src = url;
      document.body.appendChild(script);
    },
    closeUploadVideo() {
      this.$confirm('您确定要取消上传吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.dialogVisible = false
      })
    },
    // 开始上传
    stsUpload() {
      // 然后调用 startUpload 方法, 开始上传
      if(this.file) {
        if (this.uploader !== null) {
          this.uploader.startUpload();
          this.uploadDisabled = true;
          this.pauseDisabled = false;
        }
      } else if(this.isEdit) {
        this.videoUploadStep = 3
      }
      
    },
    // 暂停上传
    pauseUpload() {
      if (this.uploader !== null) {
        this.uploader.stopUpload();
        this.resumeDisabled = false;
        this.pauseDisabled = true;
      }
    },
    // 恢复上传
    resumeUpload() {
      if (this.uploader !== null) {
        this.uploader.startUpload();
        this.resumeDisabled = true;
        this.pauseDisabled = false;
      }
    },
    createUploader() {
      let self = this;
      let uploader = new AliyunUpload.Vod({
        timeout: self.timeout || 60000,
        partSize: self.partSize || 1048576,
        parallel: self.parallel || 5,
        retryCount: self.retryCount || 3,
        retryDuration: self.retryDuration || 2,
        region: self.region,
        userId: self.userId,
        // 添加文件成功
        addFileSuccess: function (uploadInfo) {
          self.uploadDisabled = false;
          self.resumeDisabled = false;
          self.statusText = "添加文件成功, 等待上传...";
        },

        // 开始上传
        onUploadstarted: function (uploadInfo) {
          // 如果是 STSToken 上传方式, 需要调用 uploader.setUploadAuthAndAddress 方法
          // 用户需要自己获取 accessKeyId, accessKeySecret,secretToken
          // 下面的 URL 只是测试接口, 用于获取 测试的 accessKeyId, accessKeySecret,secretToken
          // let stsUrl = 'http://demo-vod.cn-shanghai.aliyuncs.com/voddemo/CreateSecurityToken?BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=67999yyuuuy&AppVersion=1.0.0'
          // axios.get(stsUrl).then(({data}) => {
          //   let info = data.SecurityTokenInfo
          //   let accessKeyId = info.AccessKeyId
          //   let accessKeySecret = info.AccessKeySecret
          //   let secretToken = info.SecurityToken
          //   uploader.setSTSToken(uploadInfo, accessKeyId, accessKeySecret, secretToken)
          // })

          self.$utils
            .get("/user/upload/create-media", {
              file_name: uploadInfo.file.name,
            })
            .then((res) => {
              if (res.code == 1000) {
                self.uploadInfo = res.data;
                const uploadAuth = res.data;
                uploader.setUploadAuthAndAddress(
                  uploadInfo,
                  uploadAuth.UploadAuth,
                  uploadAuth.UploadAddress,
                  uploadAuth.VideoId
                );
                self.stsUpload();
                self.uploadingVideo = true
              } else {
                self.$notify({
                  title: "Warning",
                  message: res.msg,
                  type: "warning",
                  duration: 2000,
                });
              }
            });
          self.statusText = "文件开始上传...";
        },
        // 文件上传成功
        onUploadSucceed: function (uploadInfo) {
          // console.log("onUploadSucceed: " + uploadInfo.file.name + ", endpoint:" + uploadInfo.endpoint + ", bucket:" + uploadInfo.bucket + ", object:" + uploadInfo.object)
          self.statusText = "文件上传成功!";
        },
        // 文件上传失败
        onUploadFailed: function (uploadInfo, code, message) {
          // console.log("onUploadFailed: file:" + uploadInfo.file.name + ",code:" + code + ", message:" + message)
          self.statusText = "文件上传失败!";
        },
        // 取消文件上传
        onUploadCanceled: function (uploadInfo, code, message) {
          console.log(
            "Canceled file: " +
              uploadInfo.file.name +
              ", code: " +
              code +
              ", message:" +
              message
          );
          self.statusText = "文件已暂停上传";
        },
        // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
        onUploadProgress: function (uploadInfo, totalSize, progress) {
          // console.log("onUploadProgress:file:" + uploadInfo.file.name + ", fileSize:" + totalSize + ", percent:" + Math.ceil(progress * 100) + "%")
          let progressPercent = Math.ceil(progress * 100);
          self.stsProgress = progressPercent;
          self.statusText = "文件上传中...";
        },
        // 全部文件上传结束
        onUploadEnd: function (uploadInfo) {
          // console.log(uploadInfo)
          self.statusText = "文件上传完毕, 3s后关闭";
          self.isEnd = true;
          setTimeout(() => {
            self.videoUploadStep = 3
            console.log(self.uploadInfo)
            self.infoForm.video_url = self.uploadInfo.VideoId
            self.uploadDisabled = false
          }, 3000)
        },
      });
      return uploader;
    },
    videoChange(e) {
      this.stsProgress = 0;
      this.statusText = "";
      this.file = e.raw;
      console.log(e)
      if (!this.file) {
        alert("请先选择需要上传的文件!");
        return;
      }
      this.uploadFileName = this.file.name;
      var userData = '{"Vod":{}}';
      if (this.uploader) {
        this.uploader.stopUpload();
        this.authProgress = 0;
        this.statusText = "";
      }
      this.uploader = this.createUploader();
      // 首先调用 uploader.addFile(event.target.files[i], null, null, null, userData)
      this.uploader.addFile(this.file, null, null, null, userData);
      this.uploadDisabled = false;
      this.pauseDisabled = true;
      this.resumeDisabled = false;
      // this.isEnd = true;
    },
    // 视频封面下一步
    next() {
      // 编辑状态下可以下一步
      console.log(this.videoFilePicList);
      let videoPicParam = new FormData();
      if (this.isEdit && !this.videoFilePicList.length > 0) {
        this.videoUploadStep = 2;
        return;
      }
      if (this.videoFilePicList.length > 0 && this.videoFilePicList[0]["raw"]) {
        videoPicParam.append(
          "images",
          this.videoFilePicList[0].raw,
          this.videoFilePicList[0].name
        );
        this.isuploadPic = true;
        this.$utils
          .postFile("/user/upload/create-images", videoPicParam)
          .then((res) => {
            if (res.code == 1000) {
              this.videoUploadStep = 2;
              this.isuploadPic = false
              this.infoForm.video_cover = res.data.url
            }
          });
      } else {
        this.$message({
          message: "请选择封面",
          type: "warning",
        });
      }
    },
    // 选择视频封面
    videoPicChange(file) {
      if (!/\.(jpg|JPG|JPEG|HEIC|png|heic)$/.test(file.name)) {
        alert("封面图片格式为jpg、JPEG、png、HEIC");
        this.videoFilePicList = [];
      } else {
        if (file.size / 1024 > 10240) {
          alert("图片大小不能超过10M");
        } else {
          this.videoFilePicList = [];
          this.videoFilePicList.push(file);
        }
      }
    },
    // 获取国家列表
    getCountryList() {
      this.$utils.get('/user/get-country-list').then(res => {
        console.log(res)
        this.countryList = res.data
      })
    },
    // 获取话题列表
    getTopicList(category_id) {
      this.$utils.get('/works/getTopic', {
        category_id
      }).then(res => {
        this.topicList = res.data
      })
    },
    // 获取分类列表
    getCategoryList() {
      this.$utils.get('/works/getCategory').then(res => {
        console.log(res)
        this.categoryList = res.data
      })
    },
    categoryChange(id) {
      if(id) {
        this.getTopicList(id)
      }
    },
    closePlayer() {
      this.currentVideo.isShow = false
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.videoUploadCon {
  .add {
    width: 360px;
    height: 226px;
    background-color: #e6eaf0;
    border: 3px solid #bfcada;
    box-sizing: border-box;
    text-align: center;
    cursor: pointer;
    display: inline-block;
    vertical-align: top;
    margin-right: 13px;
    margin-bottom: 20px;
    img {
      margin-top: 50px;
    }
  }
  .videoItem {
    width: 360px;
    height: 226px;
    display: inline-block;
    vertical-align: top;
    margin-right: 13px;
    margin-bottom: 20px;
    cursor: pointer;
    position: relative;
    &:hover {
      .hoverInfo {
        opacity: 1;
        // display: block;
      }
      .coverCon {
        .info {
          display: none;
        }
        .fail {
          display: none;
        }
      }
    }
    .hoverInfo {
      // display: none;
      position: absolute;
      top: 0;
      left: 0;
      width: 360px;
      height: 226px;
      background-color: rgba(0,0,0,0.3);
      opacity: 0;
      transition: all linear 0.2s;
      .info {
        margin-left: 20px;
        margin-top: 20px;
        img {
          width: 40px;
        }
        span {
          display: inline-block;
          margin-left: 5px;
          vertical-align: top;
          margin-top: 10px;
          width: 280px;
          color: #fff;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .des {
          font-size: 20px;
          width: calc(100% - 40px);
          color: #fff;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          margin-top: 15px;
          line-height: 1.4;
        }
        .fail {
          width: calc(100% + 20px);
          height: 58px;
          line-height: 1.4;
          margin-top: 10px;
          padding: 10px;
          margin-left: -20px;
          font-size: 16px;
          color: #fff;
          box-sizing: border-box;
          background-color: #ff0707;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
        .operate {
          text-align: center;
          position: absolute;
          bottom: 20px;
          width: 100%;
          margin-left: -20px;
          .item {
            display: inline-block;
            color: #fff;
            font-size: 16px;
            margin: 0 10px;
            img {
              width: 32px;
              margin-bottom: 5px;
            }
            &:first-child {
              img {
                width: 24px;
              }
            }
            &:nth-child(3) {
              img {
                width: 28px;
              }
            }
            &:last-child {
              img {
                width: 30px;
              }
            }
          }
          .isJoin {
            cursor: auto;
          }
        }
      }
    }
    .coverCon {
      position: relative;
      .cover {
        width: 360px;
        height: 226px;
      }
      .fail {
        position: absolute;
        height: 58px;
        top: 67px;
        width: 100%;
        line-height: 1.4;
        padding: 10px;
        font-size: 16px;
        color: #fff;
        box-sizing: border-box;
        background-color: #ff0707;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .info {
        position: absolute;
        bottom: 20px;
        left: 20px;
        color: #fff;
        img {
          width: 40px;
        }
        span {
          display: inline-block;
          margin-left: 5px;
          vertical-align: top;
          margin-top: 10px;
          width: 280px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
  .uploadDialog {
      .title {
        color: #f64109;
        font-size: 18px;
      }

      .stepInfo {
        width: 100%;
        height: 62px;
        line-height: 62px;
        background-color: rgba(183, 183, 183, 0.36);
        span {
          font-size: 16px;
          color: #999;
          margin-right: 15px;
          margin-left: 15px;
        }
        .currentStep {
          color: #282828;
        }
      }
      .uploadVideoPic,
      .uploadVideoContent {
        margin-top: 35px;
        .chooseFile {
          background-color: #fff;
          border: 1px solid #ccc;
          color: #666;
          vertical-align: middle;
          img {
            vertical-align: bottom;
            margin-right: 5px;
          }
        }
        .chooseFile:hover {
          border: 1px solid #999;
        }
        .fileName {
          display: inline-block;
          margin-left: 15px;
          color: #999;
          line-height: 1.2;
          width: 295px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .imgTip {
          font-size: 14px;
          color: #999;
          margin-left: 110px;
          margin-top: 24px;
          padding-bottom: 43px;
        }
        .coverImg {
          display: inline-block;
          vertical-align: top;
          margin-left: 15px;
          img {
            width: 50px;
          }
          
        }
      }
      .uploadVideoContent {
        margin-top: 35px;
      }
      .uploading {
        text-align: center;
        padding-bottom: 20px;
        .gif {
        }
      }
      .ruleForm {
        width: 500px;
        padding-bottom: 27px;
        margin: 27px auto 0;
      }
      .footer {
        width: 100%;
        height: 77px;
        background-color: #faf6f4;
        .submitBtn {
          background-color: #f8683b;
          border: 1px solid #dc8800;
          margin-top: 20px;
          margin-left: 25px;
        }
        .loading {
          vertical-align: top;
          margin-top: 25px;
          margin-left: 10px;
        }
        .closeBtn {
          margin-left: 15px;
          color: #999;
          cursor: pointer;
        }
      }
  }
  .playContainer {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.7);
    z-index: 1;
    .closeVideo {
      position: absolute;
      right: 20px;
      top: 10px;
      font-size: 50px;
      color: #fff;
      cursor: pointer;
    }
    .player {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      width: 60%;
      height: 500px;
      margin: auto;
      .multiple-player {
        width: 60%;
        height: 500px;
      }
    }
  }
}
</style>
